<template>
    <section
        class="VibeFindMenteeStepsSection flex w-full flex-col bg-[#466DFF] bg-cover bg-no-repeat p-20 max-md:max-w-full max-md:px-5"
    >
        <div class="container">
            <div class="flex justify-center">
                <h1 class="relative inline-block pb-4 text-center text-5xl font-semibold leading-none text-white">
                    <slot />
                    <img
                        alt=""
                        class="absolute -right-8 -top-2 aspect-[0.9] w-[19px] object-contain"
                        loading="lazy"
                        src="@/assets/images/vibe/vibe-mentee-star.svg"
                    />
                </h1>
            </div>

            <section
                class="mt-20 grid grid-cols-1 text-white max-md:mt-10 max-md:max-w-full md:grid-cols-2 lg:grid-cols-4"
            >
                <div v-for="(item, index) in items" :key="index">
                    <div class="flex flex-1 gap-1.5 leading-none">
                        <img
                            :alt="`${index + 1} number icon`"
                            class="flex aspect-[0.89] w-10 shrink-0 self-start object-contain"
                            loading="lazy"
                            :src="item.icon"
                        />
                        <div class="mt-2">
                            <h2 class="my-auto text-2xl font-bold">{{ item.title }}</h2>
                            <p class="mt-4 self-end text-base leading-6">
                                {{ item.description }}
                            </p>
                        </div>
                    </div>
                </div>
            </section>

            <div class="mx-auto mt-20 w-[258px] max-w-full text-center text-base leading-4 text-[#282828] max-md:mt-10">
                <button
                    class="flex min-h-[56px] w-full items-center justify-center rounded-md border border-transparent bg-[#FFB74D] px-9 py-5 shadow-[4px_4px_0px_rgba(0,0,0,1)] transition-all hover:border-black hover:bg-[##fbbf24] hover:shadow-none focus:outline-none max-md:px-5"
                    type="button"
                    @click="openForm"
                >
                    Sign Up
                </button>
            </div>
        </div>

        <div ref="typeformEmbed" class="modal-overlay" :class="{ 'modal-visible': isFormVisible }">
            <div class="absolute right-4 top-4 z-[1001]">
                <button
                    aria-label="Close form"
                    class="rounded-full bg-white dark:bg-surface-card p-2 shadow-lg hover:bg-gray-100 hover:dark:bg-subtle"
                    @click="closeForm"
                >
                    ✕
                </button>
            </div>
            <CookieIframe
                id="typeform-full"
                allow="camera; microphone; autoplay; encrypted-media;"
                class="size-full border-0"
                src="https://iz6lf50eqrh.typeform.com/to/kRh6B7SN"
            ></CookieIframe>
        </div>
    </section>
</template>

<script setup lang="ts">
import vibe1 from '@/assets/images/vibe/vibe-1-orange.svg'
import vibe2 from '@/assets/images/vibe/vibe-2-orange.svg'
import vibe3 from '@/assets/images/vibe/vibe-3-orange.svg'
import vibe4 from '@/assets/images/vibe/vibe-4-orange.svg'
import { ref } from 'vue'

const items = ref([
    {
        title: 'Sign up to Vibe',
        description:
            'Creating an account on VIBE is very easy. Answer a set of questions so we can get to know you better.',
        icon: vibe1
    },
    {
        title: 'Take your time',
        description:
            'We invite you to answer all questions mindfully by sharing important details about yourself, your interests, and your needs.',
        icon: vibe2
    },
    {
        title: 'Sit back & relax',
        description:
            'We will take it from here! We will look for the best matches based on the information you shared with us.',
        icon: vibe3
    },
    {
        title: 'Connect',
        description: 'Now it is up to you to connect with the person you vibe with!',
        icon: vibe4
    }
])

const isFormVisible = ref(false)

const openForm = () => {
    isFormVisible.value = true
    document.body.style.overflow = 'hidden'
}

const closeForm = () => {
    isFormVisible.value = false
    document.body.style.overflow = 'auto'
}
</script>

<style scoped>
.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: white;
    z-index: 1000;
    display: none;
}

.modal-visible {
    display: block !important;
}

/* Neutral surfaces follow the selected theme; brand colors and images retain their colors. */
[data-theme="dark"] .modal-overlay {
    background: var(--color-surface-card)
}
</style>
